import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'i2a-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss']
})
export class PageContentComponent implements OnInit {
  @Input() public hasPadding: boolean;
  @Input() public headerStyle: any;
  
  constructor() { }

  ngOnInit() {
  }

}
